import React, { FC, HTMLAttributes } from 'react';
import { cn } from '../lib/utils';

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export const Skeleton: FC<SkeletonProps> = ({ className, ...props }) => {
  return (
    <div
      className={cn(
        "animate-pulse bg-slate-200 dark:bg-slate-800 rounded-input",
        className
      )}
      {...props}
    />
  );
};
